import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `combos/getComboTipoDiluyente`, method: 'GET', body: null})
}
